import { gql } from '@apollo/client';
import { AccountWithCompanyInfo } from '../types/accounts';

export type SearchAccountsByCompanyNameAndOrgId = {
  searchAccountsByCompanyNameAndOrgId: {
    accounts: AccountWithCompanyInfo[];
    totalAccounts: number;
  };
}

export type SearchAccountsByCompanyNameAndOrgIdVariables = {
  name: string;
  orgId: string;
  groupId?: string;
  skip?: number;
  limit?: number;
}

const SEARCH_ACCOUNTS_BY_COMPANY_NAME_AND_ORG_ID = gql`
  query searchAccountsByCompanyNameAndOrgId(
    $name: String!
    $orgId: ID!
    $groupId:ID
    $skip: Int
    $limit: Int
  ) {
    searchAccountsByCompanyNameAndOrgId(
      name: $name
      orgId: $orgId
      groupId: $groupId
      skip: $skip
      limit: $limit
    ) {
      accounts {
        id
        companyId
        groupId
        name
        type
        officeType
        externalId
        externalProvider
        simpleAddress
        status
        statusDescription
        erpId
        crmId
        alternateName
      }
      totalAccounts
    }
  }
`;

export default SEARCH_ACCOUNTS_BY_COMPANY_NAME_AND_ORG_ID;
